/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { AuthenticationService } from '@core/services/authentication/authentication.service';
import { navBarData, tourSteps } from './model/nav-bar-data';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { TourService } from 'ngx-ui-tour-md-menu';
import { TourMatMenuModule } from 'ngx-ui-tour-md-menu';
import { MatButtonModule } from '@angular/material/button';
import { MatListModule } from '@angular/material/list';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatExpansionModule } from '@angular/material/expansion';

import { CdkMenu, CdkMenuItem, CdkMenuTrigger } from '@angular/cdk/menu';
import { HeaderService } from '@core/services/header/header.service';
import { NavBarData } from './model/nav-bar.model';
import { ROLE_CONSTANT } from '@sharedModule/constants/role-constant';

interface NavBarToggle {
  screenWidth: number;
  collapsed: boolean;
}

interface NavItem {
  label: string;
  icon?: string;
  routeLink?: string;
  items?: NavItem[];
  isExpanded?: boolean;
  role?: string;
}

@Component({
  selector: 'app-nav-bar',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    MatIconModule,
    TourMatMenuModule,
    MatToolbarModule,
    MatButtonModule,
    MatSidenavModule,
    MatListModule,
    MatExpansionModule
],
  templateUrl: './nav-bar.component.html',
  styleUrl: './nav-bar.component.scss',
})
export class NavBarComponent implements OnInit {
  @Output() toggleNavBar: EventEmitter<NavBarToggle> = new EventEmitter();
  collapsed = false;
  screenWidth = 0;
  navData!: any[];

  tourData = tourSteps;
  constructor(
    public router: Router,
    private authenticationService: AuthenticationService,
    private matIconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer,
    public tourService: TourService,
    public headerService: HeaderService
  ) {
    this.matIconRegistry.addSvgIconSet(
      this.sanitizer.bypassSecurityTrustResourceUrl('assets/navbar.icon.svg')
    );
    const allRoutes= authenticationService.getUserPermission()
    // TODO: if userfis ADMINwm||ADMINCLIENT removing the Role from navigation
    const filteredNav = filterNavBarByPermissions(navBarData, allRoutes);
    console.log('Berfore->',filteredNav);
    
    const filteredForAdmins=filterNavBarforAdmins(filteredNav,headerService.userName().role)
    console.log('after->',filteredForAdmins);
    
    
    this.navData=filteredForAdmins;
    
  }

  ngOnInit(): void {
    this.screenWidth = window.innerWidth;
    this.tourService.initialize(this.tourData, {});
    this.startTour();
  }

  startTour(): void {
    this.tourService.start();
  }

  toggleCollapse(): void {
    this.collapsed = !this.collapsed;
    this.toggleNavBar.emit({
      collapsed: this.collapsed,
      screenWidth: this.screenWidth,
    });
  }

  logout(): void {
    this.authenticationService.initializeLogout();
  }

  toggleSubmenu(nav: NavItem): void {
    nav.isExpanded = !nav.isExpanded;

    // Close other open menus (optional)
    this.navData.forEach(item => {
      if (item !== nav && item.isExpanded) {
        item.isExpanded = false;
      }
    });
  }
}
// function filterNavByRole(navItems: any[], routes:any): NavItem[] {
//   const filtered: NavItem[] = [];
// console.log('Routes',routes);


// const userManagementRoutes = routes.filter((route:any) =>
//   route.apiEndpoint.startsWith('/user-management')
// );
// const remainingRoutes=routes.filter((route:any) =>
//   !route.apiEndpoint.startsWith('/user-management')
// );
// filtered.push(remainingRoutes);
// filtered.push({
//   routeLink: '/clientName/dashboard/user-management',
//     icon: `assets/images/nav-icon/user-management.svg`,
//     label: 'User Management',   
//     isExpanded:true,
//     items:[...userManagementRoutes]
// });

// // Structure the output as childItems array
// // const childItems = userManagementRoutes.map((item:any) => ({
// //   path: item.path
// // }));
// console.log('remainingRoutes',remainingRoutes,userManagementRoutes);

// // return {
  
// //   routeLink: '/clientName/dashboard/user-management',
// //     icon: `assets/images/nav-icon/user-management.svg`,
// //     label: 'User Management',
// //     hasAccess: false,
// //     isExpanded:true,
// //     items:[...childItems]
// // }

//   return filtered;
// }

export function filterNavBarByPermissions(navBarData: NavBarData[], permissions: any[]): NavBarData[] {
  // Extract permission endpoints for easy comparison
  const permissionEndpoints = permissions.map(permission => permission.apiEndpoint);
console.log('Endpints',permissionEndpoints);

  return navBarData
    .map(navItem => {
      // Check if this is a parent with children (User Management)
      if (navItem.items && navItem.items.length > 0) {
        const filteredItems = navItem.items.filter((childItem) =>
          // Match if the child route includes an endpoint (API endpoint is part of the routeLink)
          permissionEndpoints.some((endpoint) => childItem.routeLink.includes(`/clientName/dashboard${endpoint}`))
        );
       

        if (filteredItems.length > 0) {
          return {
            ...navItem,
            items: filteredItems
          };
        } else {
          return null;
        }
      } else {
        // Match parent route if the endpoint is included in the routeLink
        const isMatch = permissionEndpoints.some(endpoint => navItem.routeLink.includes(`/clientName/dashboard${endpoint}`));
       
        
        return isMatch ? navItem : null;
      }
    })
    .filter(navItem => navItem !== null) as NavBarData[];
}
export function filterNavBarforAdmins(navBarData:NavBarData[],role:string):NavBarData[]{
const currentRole=role;


if(currentRole===ROLE_CONSTANT.ADMIN_WM.value || currentRole===ROLE_CONSTANT.ADMIN_CLIENT.value){
  // return navBarData.filter(route=>route.label!=='Roles')
 navBarData.map(route=>{
  if(route.items&&route.items.length>0){
     route.items=route.items.filter((childRoute)=>
       childRoute.label !=="Roles"
    )
  }
  return route;
  
 })
}

return navBarData;
}